import {
  DialogFooter
} from "@/components/ui/dialog";
import { Button } from "components/ui/button";
import { Clock, Zap } from "lucide-react";
interface ReprocessModeSelectionProps {
  onSelectSync: () => void;
  onSelectAsync: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export const ReprocessModeSelection = ({
  onSelectSync,
  onSelectAsync,
  onCancel,
  isLoading,
}: ReprocessModeSelectionProps) => {

  return (
    <>
      <div className="py-1 space-y-4">
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
          <p className="text-amber-900 font-semibold mb-3 text-sm">O que sera reprocessado:</p>
          <ul className="text-amber-800 text-sm space-y-2 ml-5">
            <li className="list-disc leading-relaxed">Dados importados do banco externo serao atualizados</li>
            <li className="list-disc leading-relaxed">Divergencias manuais que voce adicionou serao mantidas</li>
          </ul>
        </div>

        <div className="pt-2">
          <p className="font-semibold text-gray-900 mb-4 text-base">Escolha o modo de processamento:</p>
          <div className="space-y-3 text-sm text-gray-700">
            <div className="flex items-start gap-2">
              <Zap className="h-4 w-4 mt-0.5 flex-shrink-0" />
              <div>
                <strong className="text-gray-900">Processar Agora:</strong>
                <span className="text-gray-600 ml-1">Aguarde na tela ate concluir (~1-2 min)</span>
              </div>
            </div>
            <div className="flex items-start gap-2">
              <Clock className="h-4 w-4 mt-0.5 flex-shrink-0" />
              <div>
                <strong className="text-gray-900">Segundo Plano:</strong>
                <span className="text-gray-600 ml-1">Continue trabalhando, receba notificacao</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DialogFooter className="sm:justify-between gap-3 pt-5">
        <Button
          onClick={onCancel}
          disabled={isLoading}
          variant={"outline"}
          className="flex-1 sm:flex-none"
        >
          Cancelar
        </Button>
        <Button
          onClick={() => {
            if (isLoading) return;
            onSelectAsync();
          }}
          disabled={isLoading}
          className="flex-1 sm:flex-none flex gap-2"
        >
          <Clock className="h-4 w-4" />
          Processar em Segundo Plano
        </Button>
        <Button
          onClick={() => {
            if (isLoading) return;
            onSelectSync();
          }}
          disabled={isLoading}
          className="flex-1 sm:flex-none flex gap-2"
        >
          <Zap className="h-4 w-4" />
          Processar Agora
        </Button>
      </DialogFooter>
    </>
  );
};
